import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import Logo from '@/components/Logo';
import Account from '@/icons/account.svg';
import routes from '@/routes';
import { cn } from '@/utils';
import { localizedRoute } from '@/utils/locale';

function Header({ className, variant = 'black', container = false, ...props }) {
	const { firstName, lastName, email } = useSelector(
		state => state.profile.user
	);

	let userName = email;

	if (firstName) {
		userName = `${firstName} ${lastName || ''}`;
	}

	const isBlackVariant = variant === 'black';

	const headerContent = (
		<>
			<Logo variant={isBlackVariant ? 'white' : 'black'} />

			<Link
				className="relative flex items-center gap-2 px-0 underline-offset-4 hover:underline"
				to={localizedRoute(routes.checkout)}
			>
				<p
					className={cn(
						'max-w-[calc(100vw-170px)] truncate text-xs leading-5 text-white md:text-sm md:leading-6',
						isBlackVariant ? 'text-white' : 'text-grey-500'
					)}
				>{`${userName}`}</p>
				<Account
					className={cn(
						'h-5 w-5',
						isBlackVariant ? 'text-white' : 'text-grey-500'
					)}
				/>
			</Link>
		</>
	);

	return (
		<>
			<header
				className={cn(
					'fixed z-20 flex h-[48px] w-full items-center justify-between px-5 lg:h-[64px] lg:px-6',
					isBlackVariant
						? 'bg-black'
						: 'border-b border-grey-200 bg-white',
					className
				)}
				{...props}
			>
				{container ? (
					<div className="flex w-full items-center justify-between md:container">
						{headerContent}
					</div>
				) : (
					headerContent
				)}
			</header>
			<div className="h-[48px] lg:h-[64px]" />
		</>
	);
}

export default Header;
